angular.module('jv.Admin.Users')
    .controller('jvAdminUsersEmplyeeAdditionalInfoController',['$scope','adminUserSVC',
        function($scope, adminUserSVC){
            $scope.additionalInfo = {};

            $scope.additionalInfo.get = function() {
                adminUserSVC.getEmployeeAdditionalInfo($scope.params.id, function(response){
                    if(response && response.msgInfo === 200){
                        $scope.additionalInfo.data = response;
                    }
                });
            };

             $scope.additionalInfo.get();
        }
    ]);